import React, { Suspense, useEffect } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CONSTANT } from "../../../config/Constant";
import PageSpinner from "../../../components/PageSpinner/PageSpinner";

const AuthLayout = () => {
  const navigate = useNavigate();
  const { token, isAppReady } = useSelector((state) => state.auth);
  const isAdmin = localStorage.getItem("isa") || "false";
  const isTenantVerified = localStorage.getItem("isTenantVerified") || "false";

  useEffect(() => {
    if (!isAppReady) return;

    if (token) {
      if (isAdmin === "true") {
        navigate(CONSTANT.ADMIN_ROUTE.TENANT);
      } else if (isTenantVerified === "false") {
        navigate(CONSTANT.ROUTE.SETTINGS);
      } else {
        navigate(CONSTANT.DEFAULT_ROUTE);
      }
    }
  }, [token, navigate, isAppReady, isAdmin, isTenantVerified]);

  return !token ? (
    <Layout className={`main__page__wrapper`}>
      <Suspense fallback={<PageSpinner size="large" fullPage={true} />}>
        <Outlet />
      </Suspense>
    </Layout>
  ) : null;
};

export default AuthLayout;
